jQuery(document).ready(function() {
	var cookie = document.cookie;
	setTimeout( function(){		
		jQuery('.newpost_fo').addClass('show');
		jQuery('.overlaynews').addClass('show');	
		jQuery('.section-header.shopify-section-group-header-group').addClass('show');
		
		jQuery(".bage-close_news a, .newsoverlay").click(function(e){  	
			jQuery('.newsoverlay').removeClass('show');	
			jQuery('.newpost_fo').removeClass('show');	
			jQuery('.section-header.shopify-section-group-header-group').removeClass('show');	
			var expiration = new Date();	
			expiration.setDate(expiration.getDate()+1);	
			document.cookie = 'popupconfirm=1;expires=' + expiration + ';path=/';	
		});
			
		/*if (cookie.indexOf('popupconfirm=', 0) == -1) {
			var expiration = new Date();
			expiration.setDate(expiration.getDate()+1);
			document.cookie = 'popupconfirm=1;expires=' + expiration + ';path=/';	
		}*/		
		if (cookie.indexOf('popupconfirm=', 0) == -1) 
		{
			jQuery('.newpost_fo').addClass('show');
			jQuery('.overlaynews').addClass('show');
			jQuery('.section-header.shopify-section-group-header-group').addClass('show');
		}
		else
		{
			jQuery('.newpost_fo').removeClass('show');
			jQuery('.overlaynews').removeClass('show');
			jQuery('.section-header.shopify-section-group-header-group').removeClass('show');
		}
	},3000);
});